export default function Intro () {
  return(
    <div className="intro">
      Diwa Reyes loves telling stories. They speak primarily in English but 
      are comfortable speaking in "Taglish"	&#40; a combination of English and Tagalog 	&#41; and 
      can also perform short stretches of dialogue in Spanish. Diwa can also perform in a number of 
      accents thanks to their international "third culture" upbringing.
    </div>
  )
}